import React, { FunctionComponent } from 'react';
import styles from '../chart.module.scss';
import { displayDateTimeFormat } from '../../../../utils/data-parser';
import { getPatientTimezone } from '../../../../contexts/PatientContext';

type ActivityTooltipProps = {
  reverse: boolean;
  date: string;
  value: {
    activityScore?: number;
    activityLevel?: number;
  };
};

const ActivityTooltip: FunctionComponent<ActivityTooltipProps> = ({ reverse, date, value }) => {
  const timezone = getPatientTimezone();
  return (
    <div className={`${reverse ? styles.chartToolTipReverse : styles.chartToolTip}`}>
      <div className={styles.chartTooltipContent}>
        <span>{displayDateTimeFormat(date, timezone)}</span>
      </div>
      {typeof value.activityLevel == 'number' && (
        <div className={styles.chartToolTipTitle}>
          <span>ACTIVITY LEVEL: </span> {value.activityLevel}
        </div>
      )}
      {typeof value.activityScore == 'number' && (
        <div className={styles.chartToolTipTitle}>
          <span>ACTIVITY SCORE: </span> {value.activityScore}
        </div>
      )}
    </div>
  );
};

export default ActivityTooltip;
